import React from 'react';
import Navbar from '../components/Navbar';
import SecondaryHero from '../components/SecondaryHero';
import OurServices from '../components/OurServices';
import OurServicesDetails from '../components/OurServicesDetails';
import Footer from '../components/Footer';
import { Helmet } from "react-helmet-async"; // ✅ Added Helmet import

const Services = () => {
  return (
    <>
      {/* ✅ SEO + Tab Title */}
      <Helmet>
        <title>Our Services | VisionBird Technologies</title>
        <meta
          name="description"
          content="Explore the wide range of digital services at VisionBird Technologies, including software development, creative design, and strategic digital solutions."
        />
      </Helmet>

      <Navbar />
      <SecondaryHero
        highlight="OUR SERVICES"
        description="At VisionBird Technologies, we believe that great companies are built by great people. As a growing software house and creative digital agency, we are always looking for passionate, skilled, and innovative individuals who want to build meaningful digital experiences and shape the future of technology.
        Our culture is built on creativity, collaboration, learning, and responsibility. Whether you’re a designer, developer, strategist, marketer, or animator, VisionBird Technologies offers a workplace where your talent is recognized, your ideas matter, and your growth is a priority."
        image="/assets/Images/Website designer-pana 1 (2).png"
      />
      <OurServicesDetails />
      <OurServices />
      <Footer />
    </>
  );
};

export default Services;